import { createAsyncAction } from 'redux-promise-middleware-actions';
import { getActionTypesResult } from '../utils';
import api from '../Api/apiIS';

export const assignReasonsConstants = {
    ASSIGN_REASONS: 'ASSIGN_REASONS'
};
export const assignReasonsConstantsFulfilledConstants = getActionTypesResult(assignReasonsConstants, '_FULFILLED');
export const assignReasonsConstantsPendingConstants = getActionTypesResult(assignReasonsConstants, '_PENDING');
export const assignReasonsConstantsRejectedConstants = getActionTypesResult(assignReasonsConstants, '_REJECTED');

export const fetchAssignReasons = createAsyncAction(
    assignReasonsConstants.ASSIGN_REASONS,
    () =>
        api.get(`deviceAssignmentReason`)
            .then(response => ({ data: response.data, })),
);
